import { makeStyles } from "tss-react/mui";

const styles = makeStyles()(() => ({
  root: {
    position: "fixed",
    inset: 0,
    zIndex: 1300,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#000",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  content: {
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxSizing: "border-box",
    marginTop: -64,
  },

  contentInner: {
    width: "100%",
    boxSizing: "border-box",
    padding: "32px 0",
  },

  contentInnerGate: {
    width: "100%",
    maxWidth: "100%",
    minHeight: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    padding: 0,
    boxSizing: "border-box",
  },
}));

export default styles;
